/**
 * Project a PlaybackState forward to `serverNowMs` using its rate.
 *
 * If paused, returns the stored position. If playing, advances position by
 * the elapsed wall time scaled by the playback rate.
 *
 * @see Jellyfin SyncPlay for the projection pattern.
 */
export function projectPosition(state, serverNowMs) {
    if (!state.isPlaying)
        return state.position;
    const elapsedSec = Math.max(0, (serverNowMs - state.updatedAt) / 1000);
    return state.position + elapsedSec * state.rate;
}
/**
 * Estimate the clock offset (serverNow - clientNow) in ms from a set of
 * round-trip samples, choosing the sample with the minimum RTT (the sample
 * least affected by queueing/network jitter).
 *
 * @returns offset in ms; add to client time to approximate server time.
 */
export function estimateClockOffset(samples) {
    if (samples.length === 0)
        return 0;
    let best = null;
    let bestRtt = Infinity;
    for (const s of samples) {
        const rtt = s.t2 - s.t0;
        if (rtt >= 0 && rtt < bestRtt) {
            bestRtt = rtt;
            best = s;
        }
    }
    if (!best)
        return 0;
    // offset = ((t1 - t0) + (t1 - t2)) / 2  =>  t1 - (t0 + t2) / 2
    return best.t1 - (best.t0 + best.t2) / 2;
}
//# sourceMappingURL=time.js.map